export default {
    blockedRoutes: (state) => state.blocked_routes,
    isRouteBlocked: (state) => (path) => state.blocked_routes.includes(path),
}
